import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles, Scissors } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { ALL_TREATMENTS } from "@/data/site";

const FEATURED = [
  "hydrafacial-medifacial-varanasi",
  "botox-dermal-fillers-varanasi",
  "skin-lightening-treatment-varanasi",
  "prp-gfc-hair-treatment-varanasi",
  "hair-transplant-varanasi",
  "scar-revision-treatment-varanasi",
];

export const AestheticHighlight = () => {
  const items = FEATURED.map((s) => ALL_TREATMENTS.find((t) => t.slug === s)).filter(Boolean);

  return (
    <section data-testid="aesthetic-highlight" className="bg-white">
      <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32 lg:px-20">
        <Reveal className="mb-12 max-w-3xl">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Beyond Dentistry
          </span>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl lg:text-6xl">
            Advanced <span className="italic text-brand-blue">Skin &amp; Hair</span> care
          </h2>
          <p className="mt-6 text-brand-muted">
            NowTreat isn&apos;t just a dental clinic. Led by Dr. Ankesh Seth — with an MSc in Facial
            Aesthetics and training in clinical cosmetology — our Paharia clinic in Varanasi offers
            medically-guided skin and hair treatments, from glowing facials and anti-ageing
            injectables to PRP hair therapy and transplants.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-2 rounded-full border border-brand-line bg-brand-soft px-4 py-2 text-sm font-medium text-brand-dark">
              <Sparkles className="h-4 w-4 text-brand-blue" /> 9 Skin Treatments
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-brand-line bg-brand-soft px-4 py-2 text-sm font-medium text-brand-dark">
              <Scissors className="h-4 w-4 text-brand-green" /> 5 Hair Treatments
            </span>
          </div>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <Reveal key={t.slug} delay={(i % 3) * 0.06}>
              <Link
                to={`/${t.slug}`}
                data-testid={`aesthetic-highlight-${t.slug}`}
                className="group relative flex h-64 flex-col justify-end overflow-hidden rounded-2xl border border-brand-line"
              >
                <img
                  src={t.image}
                  alt={`${t.name} in Varanasi`}
                  loading="lazy"
                  width="640"
                  height="400"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-brand-accent/85 via-brand-accent/25 to-transparent" />
                <div className="relative p-6">
                  <span className="inline-block rounded-full bg-white/15 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-white backdrop-blur-sm">
                    {t.category === "hair" ? "Hair" : "Skin"}
                  </span>
                  <h3 className="mt-2 font-display text-xl font-medium text-white">{t.name}</h3>
                  <span className="mt-1 inline-flex items-center gap-1 text-sm font-semibold text-brand-green">
                    Learn more
                    <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-10">
          <Link
            to="/aesthetic-treatments"
            data-testid="aesthetic-highlight-viewall"
            className="inline-flex items-center gap-2 rounded-full bg-brand-blue px-7 py-3.5 text-sm font-semibold text-white transition-all hover:bg-brand-bluehover active:scale-95"
          >
            Explore all skin &amp; hair treatments
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
